import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { showModal } from "../../slice/authModalSlice";
import { Route } from "react-router-dom";

const ProtectedRoute = ({ children, ...rest }) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.user._id);

  return (
    <Route {...rest}>
      {isAuthenticated ? (
        children
      ) : (
        <div className="d-flex justify-content-center align-items-center mt-9">
          <button
            className="primary-btn"
            onClick={() => dispatch(showModal("login"))}
          >
            This page is only for logged in user.
            <br></br>
            Please log in to continue!
          </button>
        </div>
      )}
    </Route>
  );
};

export default ProtectedRoute;
